/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: BftYWjxj5zbk
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicInputFieldUnderline.module.css"; // plasmic-import: BftYWjxj5zbk/css

createPlasmicElementProxy;

export const PlasmicInputFieldUnderline__VariantProps = new Array(
  "status",
  "padding",
  "onSurface"
);

export const PlasmicInputFieldUnderline__ArgProps = new Array(
  "placeholder",
  "type",
  "inputName",
  "required",
  "id",
  "value",
  "onClick"
);

const $$ = {};

function PlasmicInputFieldUnderline__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          type: "text",
          required: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textbox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $props.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      },
      {
        path: "padding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.padding
      },
      {
        path: "onSurface",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.onSurface
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <input
      data-plasmic-name={"textbox"}
      data-plasmic-override={overrides.textbox}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      autoComplete={"off"}
      className={classNames(
        projectcss.all,
        projectcss.input,
        projectcss.input__fRuRb,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.textbox,
        {
          [sty.textboxonSurface_onGrey]: hasVariant(
            $state,
            "onSurface",
            "onGrey"
          ),
          [sty.textboxpadding_noPadding]: hasVariant(
            $state,
            "padding",
            "noPadding"
          ),
          [sty.textboxstatus_error]: hasVariant($state, "status", "error"),
          [sty.textboxstatus_normal]: hasVariant($state, "status", "normal")
        }
      )}
      id={(() => {
        try {
          return $props.id;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      name={(() => {
        try {
          return $props.inputName;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onChange={async (...eventArgs) => {
        (e => {
          generateStateOnChangeProp($state, ["textbox", "value"])(
            e.target.value
          );
        }).apply(null, eventArgs);
      }}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      placeholder={(() => {
        try {
          return $props.placeholder;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      ref={ref => {
        $refs["textbox"] = ref;
      }}
      required={(() => {
        try {
          return $props.required;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      type={(() => {
        try {
          return $props.type;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return "text";
          }
          throw e;
        }
      })()}
      value={generateStateValueProp($state, ["textbox", "value"]) ?? ""}
    />
  );
}

const PlasmicDescendants = {
  textbox: ["textbox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInputFieldUnderline__ArgProps,
          internalVariantPropNames: PlasmicInputFieldUnderline__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInputFieldUnderline__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "textbox") {
    func.displayName = "PlasmicInputFieldUnderline";
  } else {
    func.displayName = `PlasmicInputFieldUnderline.${nodeName}`;
  }
  return func;
}

export const PlasmicInputFieldUnderline = Object.assign(
  // Top-level PlasmicInputFieldUnderline renders the root element
  makeNodeComponent("textbox"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicInputFieldUnderline
    internalVariantProps: PlasmicInputFieldUnderline__VariantProps,
    internalArgProps: PlasmicInputFieldUnderline__ArgProps
  }
);

export default PlasmicInputFieldUnderline;
/* prettier-ignore-end */
